const isMAIQUser = (roles) => {
  const role = roles;
  // If roles is an array, check if EVERY element has "maiq"
  if (Array.isArray(role)) {
      return role.every(r => r.toLowerCase().includes("maiq"));
  }
  // If roles is a string, check if it contains "maiq"
  else if (typeof role === 'string') {
      return role.toLowerCase().includes("maiq");
  }
  // For any other case (null, undefined, object, etc.)
  return false;
};

const isSuperUser = (roles) => {
  const role = roles;
  // If roles is an array, check if EVERY element has "maiq"
  if (Array.isArray(role)) {
      return role.every(r => r.toLowerCase().includes("super"));
  }
  // If roles is a string, check if it contains "maiq"
  else if (typeof role === 'string') {
      return role.toLowerCase().includes("super");
  }
  // For any other case (null, undefined, object, etc.)
  return false;
};

const isSalesUser = (roles) => {
  const role = roles;
  
  // If roles is an array, check if EVERY element has "sales" (case-insensitive)
  if (Array.isArray(role)) {
    return role.every(r => r.toLowerCase().includes("sales"));
  }
  // If roles is a string, check if it contains "sales" (case-insensitive)
  else if (typeof role === 'string') {
    return role.toLowerCase().includes("sales");
  }
  // For any other case (null, undefined, object, etc.)
  return false;
};

const isDealershipUser = (roles) => {
  const role = roles;
  
  // If roles is an array, check if EVERY element has "sales" (case-insensitive)
  if (Array.isArray(role)) {
    return role.every(r => r.toLowerCase().includes("dealership"));
  }
  // If roles is a string, check if it contains "sales" (case-insensitive)
  else if (typeof role === 'string') {
    return role.toLowerCase().includes("dealership");
  }
  // For any other case (null, undefined, object, etc.)
  return false;
};

export default {
  isMAIQUser,
  isSuperUser,
  isSalesUser,
  isDealershipUser,
}